module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_8023.4a65694a.png";